module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("layout_admin_paymentdetailsconfirm", [["div",{"id":"paydet-confirm-wrapper","class":"paydet-confirm-wrapper"},[["section",{"class":"header-section"},[["a",{"href":"/","class":"logo"}]]],["section",{"class":"body-section"},[["div",{"id":"paydet-confirm-container"}]]]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/templates/layout/admin/paymentDetailsConfirm.tpl
// module id = 242
// module chunks = 2